export const QuestionSurveysActionTypes = {
  API_RESPONSE_SUCCESS: '@@question-survey/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@question-survey/API_RESPONSE_ERROR',

  GET_QUESTION_SURVEY: '@@question-survey/GET_QUESTION_SURVEY',
  LIST_QUESTION_SURVEYS: '@@question-survey/LIST_QUESTION_SURVEYS',
  ADD_QUESTION_SURVEY: '@@question-survey/ADD_QUESTION_SURVEY',
  UPDATE_QUESTION_SURVEY: '@@question-survey/UPDATE_QUESTION_SURVEY',
  DELETE_QUESTION_SURVEY: '@@question-survey/DELETE_QUESTION_SURVEY',

  RESET: '@@question-survey/RESET'
}
